import { Injectable, NgModule } from "@angular/core";
import { Routes, RouterModule, Resolve } from "@angular/router";
import { LoggedInGuard } from "../auth/auth.guards";
import { AccountPrerequisitesGuard } from "../prerequisites/account-prerequisites.guard";
import { SessionService } from "../session.service";
import { DashboardComponent } from "./dashboard.component";
import { DashboardService } from "./dashboard.service";

@Injectable({ providedIn: "root" })
export class StartDateResolve implements Resolve<any> {
  constructor() {}

  resolve() {
    const start = new Date();
    start.setMonth(start.getMonth() - 1);
    start.setHours(0, 0, 0, 0);
    return start;
  }
}

@Injectable({ providedIn: "root" })
export class EndDateResolve implements Resolve<any> {
  constructor() {}

  resolve() {
    const end = new Date();
    end.setHours(23, 59, 59);
    return end;
  }
}

@Injectable({ providedIn: "root" })
export class DashboardResolve implements Resolve<any> {
  constructor(
    private SessionService: SessionService,
    private DashboardService: DashboardService,
  ) {}

  resolve() {
    return this.DashboardService.getDashboard(
      this.SessionService.currentAccountValue!.accountID,
      this.SessionService.currentAppValue!.id,
    );
  }
}

const routes: Routes = [
  {
    path: "",
    component: DashboardComponent,
    data: { title: "Dashboard", sidebar: "dashboard" },
    resolve: {
      start: StartDateResolve,
      end: EndDateResolve,
    },
    canActivate: [LoggedInGuard, AccountPrerequisitesGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardRoutingModule {}

const dashboardModuleLazyLoadRoutes: Routes = [
  {
    path: "dashboard",
    loadChildren: () =>
      import("./dashboard.module").then((m) => m.DashboardModule),
  },
];

export { dashboardModuleLazyLoadRoutes };
